import React, { useRef, useEffect } from 'react';

const DotsAnimation = () => {
  const canvasRef = useRef(null);
  const dots = useRef([]);
  const mouse = useRef({ x: null, y: null });
  const numDots = 110; // Number of dots on the screen
  const maxDistance = 100; // Max distance to connect dots

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    // Create a random dot with position and speed
    function createDot() {
      return {
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        radius: (Math.random() * 0.7 + 0.3) * 3,
        speedX: Math.random() * 3 - 2,
        speedY: Math.random() * 3 - 2,
      };
    }

    // Create all dots
    for (let i = 0; i < numDots; i++) {
      dots.current.push(createDot());
    }

    // Animate the dots and connections
    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';

      // Update the position of each dot
      for (const dot of dots.current) {
        ctx.beginPath();
        ctx.arc(dot.x, dot.y, dot.radius, 0, Math.PI * 2);
        ctx.fill();

        dot.x += dot.speedX;
        dot.y += dot.speedY;

        // Bounce off walls
        if (dot.x + dot.radius > canvas.width || dot.x - dot.radius < 0) {
          dot.speedX = -dot.speedX;
        }

        if (dot.y + dot.radius > canvas.height || dot.y - dot.radius < 0) {
          dot.speedY = -dot.speedY;
        }
      }

      // Connect dots that are close to the mouse
      if (mouse.current.x !== null && mouse.current.y !== null) {
        for (const dot of dots.current) {
          const dx = dot.x - mouse.current.x;
          const dy = dot.y - mouse.current.y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          // Check if the dot is within the connection distance
          if (distance < maxDistance) {
            ctx.beginPath();
            ctx.moveTo(dot.x, dot.y);
            ctx.lineTo(mouse.current.x, mouse.current.y);
            ctx.strokeStyle = `rgba(255, 255, 255, ${1 - distance / maxDistance})`;
            ctx.lineWidth = 2.9;
            ctx.stroke();
          }
        }
      }

      requestAnimationFrame(animate);
    }

    animate();

    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    const handleMouseMove = (event) => {
      mouse.current.x = event.clientX;
      mouse.current.y = event.clientY;
    };

    const handleMouseLeave = () => {
      mouse.current.x = null;
      mouse.current.y = null;
    };

    window.addEventListener('resize', handleResize);
    canvas.addEventListener('mousemove', handleMouseMove);
    canvas.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      window.removeEventListener('resize', handleResize);
      canvas.removeEventListener('mousemove', handleMouseMove);
      canvas.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return <canvas ref={canvasRef} className="background-canvas" />;
};

export default DotsAnimation;
